import { useSetActivePackMutation, type AvatarItem, type AvatarMesh, type AvatarAnimationPack } from '@/services/avatarApi';
import { useHaptics } from '@/hooks/useHaptics';
import { cn } from '@/lib/cn';

const LIBRARY_LABEL: Record<string, string> = {
  'tripo-utility': 'Action',
  'meshy-dancing': 'Dancing',
};

function readyPacks(mesh: AvatarMesh | undefined): AvatarAnimationPack[] {
  if (!mesh?.animationPacks) return [];
  return mesh.animationPacks.filter(p => p.status === 'ready');
}

interface Props {
  avatar: AvatarItem;
}

export function PackSwitcher({ avatar }: Props) {
  const haptics = useHaptics();
  const [setActivePack, { isLoading }] = useSetActivePackMutation();
  const packs = readyPacks(avatar.mesh);
  if (packs.length < 2) return null;
  const activeId = avatar.mesh?.activePackId;

  const onPick = (packId: string) => {
    if (packId === activeId) return;
    haptics.impact('light');
    setActivePack({ avatarId: avatar._id, packId });
  };

  return (
    <div className="flex w-full rounded-full bg-bg-tertiary p-1">
      {packs.map(pack => {
        const label = LIBRARY_LABEL[pack.library] ?? pack.library;
        const active = pack.packId === activeId;
        return (
          <button
            key={pack.packId}
            type="button"
            disabled={isLoading}
            onClick={() => onPick(pack.packId)}
            className={cn(
              'flex-1 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors',
              active ? 'bg-brand text-bg' : 'bg-transparent text-fg-muted',
              isLoading && 'opacity-50',
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
